import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Users, Trash2, Pencil, Check, X } from 'lucide-react';

export const StudentsTable = ({ students, editingCode, setEditingCode, onSaveCode, onDelete }) => (
      <Card className="bg-card border-border">
        <CardContent className="p-0">
          {students.length > 0 ? (
            <Table>
              <TableHeader>
                <TableRow className="hover:bg-transparent">
                  <TableHead className="text-xs uppercase tracking-wider text-muted-foreground">Prénom</TableHead>
                  <TableHead className="text-xs uppercase tracking-wider text-muted-foreground">Nom</TableHead>
                  <TableHead className="text-xs uppercase tracking-wider text-muted-foreground">Classe</TableHead>
                  <TableHead className="text-xs uppercase tracking-wider text-muted-foreground">Identifiant</TableHead>
                  <TableHead className="text-xs uppercase tracking-wider text-muted-foreground w-12"></TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {students.map((s) => (
                  <TableRow key={s.student_id} className="hover:bg-muted/30 transition-colors" data-testid={`student-row-${s.student_id}`}>
                    <TableCell className="font-medium">{s.prenom}</TableCell>
                    <TableCell>{s.nom}</TableCell>
                    <TableCell>
                      <span className="px-2 py-1 text-xs rounded-full bg-primary/10 text-primary">{s.classe}</span>
                    </TableCell>
                    <TableCell>
                      {editingCode?.studentId === s.student_id ? (
                        <div className="flex items-center gap-1">
                          <Input
                            className="w-28 h-7 text-xs font-mono"
                            value={editingCode.code}
                            onChange={(e) => setEditingCode({ ...editingCode, code: e.target.value.replace(/\D/g, '').slice(0, 8) })}
                            maxLength={8}
                            data-testid={`edit-code-input-${s.student_id}`}
                          />
                          <Button variant="ghost" size="sm" className="h-7 w-7 p-0 text-emerald-400" onClick={() => onSaveCode(s.student_id)} data-testid={`save-code-${s.student_id}`}><Check className="w-3.5 h-3.5" /></Button>
                          <Button variant="ghost" size="sm" className="h-7 w-7 p-0 text-muted-foreground" onClick={() => setEditingCode(null)}><X className="w-3.5 h-3.5" /></Button>
                        </div>
                      ) : (
                        <button
                          onClick={() => setEditingCode({ studentId: s.student_id, code: s.student_code || '' })}
                          className="font-mono text-xs px-2 py-1 rounded bg-muted/50 hover:bg-muted transition-colors cursor-pointer flex items-center gap-1.5"
                          data-testid={`student-code-${s.student_id}`}
                          title="Cliquez pour modifier"
                        >
                          {s.student_code || '—'}
                          <Pencil className="w-3 h-3 text-muted-foreground" />
                        </button>
                      )}
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="ghost" size="sm"
                        onClick={() => onDelete(s.student_id)}
                        data-testid={`delete-student-${s.student_id}`}
                        className="text-muted-foreground hover:text-destructive"
                      >
                        <Trash2 className="w-4 h-4" />
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <div className="text-center py-16">
              <Users className="w-12 h-12 mx-auto mb-4 text-muted-foreground" strokeWidth={1} />
              <p className="text-muted-foreground">Aucun élève. Importez un CSV ou ajoutez manuellement.</p>
            </div>
          )}
        </CardContent>
      </Card>
);
